import { Table } from "element-ui";
import ColumnsFactory from "./ColumsFactory";
import "./table.css";
/**
 * talbeCols column attrobutes
 * https://element.eleme.io/#/zh-CN/component/table#table-column-attributes
 */
const RCList = args => {
  const { props, listeners } = args;
  const RCSelectionChange = listeners.selectionChange || function() {};
  const { talbeCols, data } = props;
  const cols = talbeCols.map(item => {
    if (item.dataType == "number") {
      item.align = item.align || "right";
    } else if (item.dataType == "text") {
      item.align = item.align || "left";
    }

    const ColArg = {
      props: item
    };
    // render 方法存在是 使用 render 方法去构建 table col
    //  render 方法一定要是箭头函数的方法，用来自动注入 h
    if (item.render) {
      ColArg.scopedSlots = {
        default: scopes => {
          if (item.render) return item.render(scopes);
        }
      };
    }

    return <ColumnsFactory {...ColArg}></ColumnsFactory>;
  });

  return (
    <Table
      data={data}
      stripe
      row-key="uuid"
      tree-props={{ children: "children", hasChildren: "hasChildren" }}
      headerRowClassName="RCTableHeader"
      cellClassName="RCTableCell"
      onSelection-change={RCSelectionChange}
    >
      {cols}
    </Table>
  );
};

export default RCList;
